module.exports = __webpack_public_path__ + "static/media/page-icon.6f0e87a9.svg";